import { render, staticRenderFns } from "./VenuePaymentMethod.vue?vue&type=template&id=2633670a&"
import script from "./VenuePaymentMethod.vue?vue&type=script&lang=ts&"
export * from "./VenuePaymentMethod.vue?vue&type=script&lang=ts&"
import style0 from "./VenuePaymentMethod.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports